<template>
  <div class="header">
    <div class="header-logo">
      <el-image :src="require('@/assets/images/logo.png')"></el-image>
      <div>仪表盘运营管理后台</div>
    </div>
    <el-dropdown
      trigger="click"
      placement="bottom-end"
      @command="handleCommand"
    >
      <span class="el-dropdown-link">
        <el-image
          :src="require('@/assets/images/header-user.png')"
          fit="fill"
        ></el-image>
        <span>你好，{{ userInfo?.realName || userInfo?.username }}</span>
        <i class="el-icon-caret-bottom" style="color: #c0c4cc"></i>
      </span>
      <el-dropdown-menu class="header-dropdown" slot="dropdown">
        <el-dropdown-item command="b">
          <div class="logout">
            <img class="back-img" src="../../assets/images/back.png" />
            <span>退出登录</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  computed: {
    userInfo() {
      return this.$store.state.app.userInfo;
    },
  },
  mounted() {},
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'b':
          this.handleLoginOut();
          break;
        default:
          break;
      }
    },
    handleLoginOut() {
      this.$confirm('您确定要退出登录吗?', '提示', {
        confirmButtonText: '退出登录',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$store.dispatch('app/loginOut');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  background: url('~@/assets/images/top-bg.png') center no-repeat;
  background-size: 100% 60px;
  box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.1);
  .header-logo {
    display: inline-flex;
    align-items: center;
    height: 60px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    .el-image {
      margin-right: 10px;
      width: 40px;
    }
  }

  .el-dropdown-menu {
    padding: 5px 0 !important;
  }

  .el-dropdown {
    cursor: pointer;
    font-size: 16px;
    margin-left: 20px;
    height: 60px;
    line-height: 60px;
    color: #fff;

    .el-dropdown-link .el-image {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      border-radius: 16px;
      margin-right: 8px;
      ::v-deep .image-slot {
        width: 32px;
        height: 32px;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }

    .el-avatar--circle {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
.logout {
  display: flex;
  justify-content: center;
  align-items: center;
}
.back-img {
  width: 20px;
  height: 20px;
  margin-right: 11px;
}
</style>
